<template>
  <vs-popup class="customer-sample-order-create-popup"
            title="SUNDRY ITEM ORDER CREATE"
            @close="onClickClose"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateRmOrder)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
                  <vs-table id="popup" :data="cartItems" stripe>
                    <template slot="header">
                      <h3>

                      </h3>
                    </template>
                    <template slot="thead">
                      <vs-th width="10%">ITEM CODE</vs-th>
                      <vs-th width="10%">PRODUCT CODE</vs-th>
                      <vs-th width="10%">PRODUCT NAME</vs-th>
                      <vs-th width="10%">SUPPLIER</vs-th>
                      <vs-th width="10%">QUANTITY</vs-th>
                      <vs-th width="10%">SOLD IN</vs-th>
                      <vs-th width="10%">UNIT PRICE Excl VAT (GBP)</vs-th>
                      <vs-th width="10%">TOTAL PRICE Excl VAT (GBP)</vs-th>
                      <vs-th width="10%">VAT (GBP)</vs-th>
                      <vs-th width="10%"></vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].sundry_item_code">
                          {{ data[indextr].sundry_item_code }}
                        </vs-td>
                        <vs-td :data="data[indextr].sundry_product_code">
                          {{ data[indextr].sundry_product_code }}
                        </vs-td>

                        <vs-td :data="data[indextr].sundry_product_name">
                          {{ data[indextr].sundry_product_name }}
                        </vs-td>

                        <vs-td :data="data[indextr].sundry_supplier">
                          {{ data[indextr].sundry_supplier }}
                        </vs-td>

                        <vs-td :data="data[indextr].quantity">
                          <ValidationProvider :vid="indextr + 'quantity' " :name="indextr + 'quantity'" :rules="'required|integer|moq:'+data[indextr].min_OQ" v-slot="{ errors }">
                            <vs-input   type="text" v-model="data[indextr].quantity" class="w-full"
                                      :name="'quantity'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                          </ValidationProvider>
                        </vs-td>

                        <vs-td :data="data[indextr].sold_in">
                          {{ data[indextr].sold_in }}
                        </vs-td>

                        <vs-td :data="data[indextr].unit_price">
                          {{ data[indextr].unit_price }}
                        </vs-td>

                        <vs-td :data="data[indextr].price">
                          {{data[indextr].quantity ? (Number(data[indextr].unit_price) * data[indextr].quantity).toFixed(2) : '0.00'}}
                        </vs-td>

                        <vs-td :data="data[indextr].vat">
                          <ValidationProvider :vid="indextr + 'vat' " :name="indextr + 'vat'" rules="required" v-slot="{ errors }">
                            <vs-input  type="text" v-model="data[indextr].vat" class="w-full"
                                       :name="'vat'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                          </ValidationProvider>
                        </vs-td>


                        <vs-td :data="data[indextr].id">
                          <vx-tooltip class="" text="Remove from cart" position="left">
                            <vs-button @click="onClickRemoveFromCart(data[indextr].id)"
                                       size="small" color="danger" type="border" icon-pack="feather" icon="icon-delete">Remove</vs-button>
                          </vx-tooltip>
                        </vs-td>

                      </vs-tr>
                      <vs-tr>
                        <vs-td style="font-weight: bolder">Total</vs-td>
                        <vs-td></vs-td>
                        <vs-td></vs-td>
                        <vs-td></vs-td>
                        <vs-td></vs-td>
                        <vs-td></vs-td>
                        <vs-td></vs-td>
                        <vs-td style="font-weight: bolder">{{totalCalculator()}}</vs-td>
                        <vs-td></vs-td>
                        <vs-td></vs-td>
                      </vs-tr>
                    </template>

                  </vs-table>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full md:mb-0">
              <vx-card no-shadow>
               <span>
                  <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="line1" name="line1" rules="required" v-slot="{ errors }">
                      <small class="label">Address Line 1</small>
                      <vs-input v-model="form.line1"  name="line1" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="line2" name="line2" rules="" v-slot="{ errors }">
                      <small class="label">Address Line 2</small>
                      <vs-input v-model="form.line2"  name="line2" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="line3" name="line3" rules="" v-slot="{ errors }">
                      <small class="label">Address Line 3</small>
                      <vs-input v-model="form.line3"  name="line3" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="town_state" name="town_state" rules="required" v-slot="{ errors }">
                      <small class="label">Town / State</small>
                      <vs-input v-model="form.town_state"  name="town_state" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="post_code" name="post_code" rules="required" v-slot="{ errors }">
                      <small class="label">Postal Code</small>
                      <vs-input v-model="form.post_code"  name="post_code" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">
                      <small class="label">Country</small>
                      <v-select :filter-by="myFilter" :clearable="false" name="country" placeholder=""
                                label="name" v-model="form.country" :reduce="option => option.name"
                                :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                 <div class="vx-row mb-3">
                   <div class="vx-col md:w-1/3 w-full md:mb-0">
                      <ValidationProvider vid="sage_department" name="sage_department" rules="required" v-slot="{errors}">
                        <small class="label">Sage Department</small>
                          <v-select :filter-by="myFilter" :clearable="false" name="sage_department" placeholder=""
                                    label="name" v-model="form.sage_department_id" :reduce="option => option.id"
                                    :options="sage_departments" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                          <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>
                   </div>
                   <div class="vx-col md:w-1/3 w-full md:mb-0">
                    <ValidationProvider vid="region" name="region" rules="required" v-slot="{errors}">
                      <small class="label">Region</small>
                        <v-select :filter-by="myFilter" :clearable="false" name="region" placeholder=""
                                  label="name" v-model="form.region_id" :reduce="option => option.id"
                                  :options="regions" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                   </div>
                   <div class="vx-col md:w-1/3 w-full md:mb-0">
                     <ValidationProvider vid="required_by" name="required_by" rules="required" v-slot="{ errors }">
                        <small class="label">Required By Date</small>
                        <flat-pickr class="w-full"
                                    style="display: none"
                                    :config="{ dateFormat: 'd/m/Y'}"
                                    v-model="form.required_by"
                                    placeholder="Choose Date"
                        />
                      <flat-pickr class="w-full"
                                  :config="{ dateFormat: 'd/m/Y'}"
                                  v-model="form.required_by"
                                  placeholder="Choose Date"
                      />
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                   </div>
                 </div>

               </span>

                <div class="vx-row mb-3">
                  <div class="vx-col w-full">
                    <ValidationProvider vid="delivery_instruction" name="delivery_instruction" rules="" v-slot="{ errors }">
                      <small class="label">Delivery Instructions</small>
                      <vs-textarea class="mb-0" v-model="form.delivery_instruction" height="100px" />
                      <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="vx-row mb-3">
                  <div class="vx-col w-full">
                    <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                      <small class="label">Note</small>
                      <vs-textarea class="mb-0" v-model="form.note" height="100px" />
                      <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>

              </vx-card>
            </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Order</vs-button>
            <vs-button @click="open =false" class="ml-4 mt-2" type="border" color="warning">Cancel</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import SageFactory from "@/mixins/SageFactory";
  import flatPickr from 'vue-flatpickr-component'

  const CustomerRepository = RepositoryFactory.get('customer')
  const InventoryRepository = RepositoryFactory.get('inventory')
  const SundrySupplierRepository = RepositoryFactory.get('sundry')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');
  const FormulationsRepository = RepositoryFactory.get('formulations');
  const RegionsRepository = RepositoryFactory.get('regions');
  const SageSettingsRepository = RepositoryFactory.get('sage_settings');
  const SettingsRepository = RepositoryFactory.get('settings');
  const CompanyAddressRepository = RepositoryFactory.get('company_address');

  function initialState() {
    return {
      open: false,
      id: '',
      form: {
        line1: '',
        line2: '',
        line3: '',
        town_state: '',
        post_code: '',
        country: '',
        delivery_instruction: '',
        note: '',
        raw_material_items: [],
        required_by:''
      },
      countryCodes: [],
      cartItems: [],
      onClickAddressChange: true,
      sage_departments:[],
      regions:[],
    }
  }

export default {
  name: 'CreateSundryItemOrderPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup () {
      try {
        await Object.assign(this.$data, initialState())
        await this.getCountryCodes()
        await this.getItemsInItemsCart()
        await this.getSageDepartments()
        await this.getRegions()
        await this.fetchSettings()
        this.open = true;
      } catch (error) {

      }
    },
    async onClickClose() {
      const vue = this;
      this.open = false
      await vue.$parent.onlyRefreshData()
    },
    closeUpdate() {
      this.open = true
    },
    onClose() {
      this.open = false
    },
    async onClickCreateRmOrder () {
      const vue = this;
      await this.$vs.loading({
        container: '#popup',
        scale: 0.45
      })
       try {
         const payload = this.form
         payload.sundry_items = this.cartItems.map((n) => {
           return {id: n.sundry_item_id, quantity: n.quantity, price: Number(n.unit_price).toFixed(2), vat: Number(n.vat).toFixed(2)}
         })
         const response = (await SundrySupplierRepository.createSundryOrder(payload)).data.data
          if(!this.$can('create-edit-sage-purchase-order')) {
            return
          }
         if(response.sundry_supplier_sage_id === ""){
           this.open = false
           const text = `The following supplier(s) is not set up on Sage.you will need to manually synchronise
                          all orders from this purchase OR activate that supplier in Sage. Order ID:${response.sundry_order_code}`
           this.$vs.dialog({
             type: 'confirm',
             color: 'warning',
             title: 'Note',
             acceptText: 'OK',
             text: text,
             cancel: this.closeUpdate
           })
         }else{
           await this.createSageSundryItemOrder(response)
           this.showSuccessMessage('Sundry item order created successfully')
         }
         this.open = false
         await vue.$parent.refreshData()
       }catch (e) {
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close('#popup > .con-vs-loading')
    },
    async getCountryCodes() {
      this.$vs.loading()
      this.countryCodes = (await SupplierManufactureRepository.getCountryCodes()).data.data;
      this.$vs.loading.close()
    },
    async fetchSettings(){
      this.$vs.loading()

      try {
        const settings = (await SettingsRepository.getTheItem('order_delivery_instructions')).data.data
        this.form.delivery_instruction = settings.order_delivery_instructions

        const { data: addresses } = (await CompanyAddressRepository.getCompanyAddresses('filter[is_default]=1')).data
        const defaultAddress = addresses[0]
        if (defaultAddress) {
          this.form.line1 = defaultAddress.line1 || ''
          this.form.line2 = defaultAddress.line2 || ''
          this.form.line3 = defaultAddress.line3 || ''
          this.form.town_state = defaultAddress.town_state || ''
          this.form.post_code = defaultAddress.post_code || ''
          this.form.country = defaultAddress.country || ''
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }

      this.$vs.loading.close()
    },
    async getSageDepartments(){
      this.$vs.loading()
      const {data} = await SageSettingsRepository.getListOfSageDepartments('','','',0)
      this.sage_departments =  data.data
      this.$vs.loading.close()
    },
    async getRegions(){
      this.$vs.loading()
      const {data} = await RegionsRepository.getListOfRegions()
      this.regions =  data.data
      this.$vs.loading.close()
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },
    async getItemsInItemsCart() {
      await this.$vs.loading({
        container: '#popup',
        scale: 0.45
      })
      try {
        const {data} = (await SundrySupplierRepository.getListOfSundryItemCart()).data
        this.cartItems = data
        this.cartItems.forEach(item => {
          item.vat = 0
        })
      }catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#popup > .con-vs-loading')
    },
    async onClickRemoveFromCart(id) {
      await this.$vs.loading({
        container: '#popup',
        scale: 0.45
      })
      try {
        await SundrySupplierRepository.removeItemFromCart(id)
        await this.getItemsInItemsCart()
        this.showSuccessMessage('Sundry item removed from the cart')
      }catch (e) {

        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#popup > .con-vs-loading')
    },
    async onClickUpdateItemFromCart(data) {
      await this.$vs.loading({
        container: '#popup',
        scale: 0.45
      })
      try {
        const payload = {quantity: data.quantity, vat: Number(data.vat).toFixed(2)}
        await SundrySupplierRepository.updateItemFromCart(data.id, payload)
        await this.getItemsInItemsCart()
        this.showSuccessMessage('Sundry item qty updated!')
      }catch (e) {

        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#popup > .con-vs-loading')
    },
    totalCalculator() {
      let total = 0;
      this.cartItems.forEach((m) => {
        if (!!m.unit_price) {
          total = total + Number(m.unit_price) * Number(m.quantity)
        }
      })
      return total.toFixed(2)
    },
    onChangeQty(data) {
      if (Number(data.quantity) >= Number(data.min_OQ)) {
        this.updateCart(data, this)
      }
    },
    updateCart: _.debounce( async (data, vm) => {
      await vm.onClickUpdateItemFromCart(data)
    }, 500),
  },

  computed: {
    checkAllItemsInSameSupplier: function () {
      const suppliers = this.cartItems.map((n) => n.supplier)
      return suppliers.every( (val, i, arr) => val === arr[0] )
    }
  },
  components: {
    'v-select': vSelect,
    flatPickr
  },
  mixins: [SuccessMessage, ErrorMessages, SageFactory],
}
</script>

<style scoped>
  .customer-sample-order-create-popup >>> .vs-popup {
    min-width: 95% !important;
  }
  .loader {
    text-align: center;
    color: #bbbbbb;
  }

</style>
